import React from 'react';
import { Box, Skeleton } from '@mui/material';

const TopActiveReposSkeleton = () => (
  <Box>
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
    <Skeleton sx={{ height: '56px' }} />
  </Box>
);

export default TopActiveReposSkeleton;
